import React, {FC, useEffect, useState} from 'react';
import {Airfield} from "../../models/Airfield";
import {AirfieldService} from "../../services/AirfieldService";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Grid,
    Skeleton,
    Table,
    TableBody,
    Tooltip,
    Typography,
    useMediaQuery,
} from '@material-ui/core';
import {useTranslation} from "react-i18next";
import {PaginationResult} from "../../types/paginationResult";
import Scrollbar from '../../components/Scrollbar';
import {useTheme} from '@material-ui/system';
import CardLoader from '../../components/CardLoader';
import verifiedShield from '../../images/verified_Shield.png';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';


interface image {
    albumId: number
    id: number,
    title: string,
    url: string,
    thumbnailUrl: string
}

interface AirfieldsPublicListProps {
    airfields: PaginationResult<Airfield>;
    recordLimit: number;
    isLoading: boolean
}




const AirfieldsPublicMobileList: FC<AirfieldsPublicListProps> = (props) => {
    const { airfields, recordLimit, isLoading } = props;
    //From AirfieldList.tsx
    const { t } = useTranslation();
    const history = useNavigate();
    var currentTheme = useTheme();
    var isSmallMobile = useMediaQuery(currentTheme.breakpoints.down(520));
    const airfieldService = new AirfieldService();


    const [data, setData] = useState<string[]>([]);
    const [isLoadaingPhoto, setIsLoadaingPhoto] = useState<boolean>();

    useEffect(() => {
    }, [isLoading, airfields.items]);








    const handleClick = (urlLink: string) => {
        history(urlLink);
    }


    return (

        <Container maxWidth={false}>


            <Scrollbar>
                {isLoading ?
                    (<><Box justifyContent={""}><CardLoader rowsNum={10} height={400} /></Box></>) :
                    (<Table>

                        <TableBody>
                            <>
                                {airfields?.items.map((airfield, index) => (
                                    <><Container>
                                        <Card sx={{ mt: 3, maxWidth: 700 }}>
                                            {airfield.firstPhotoUrl == undefined ? (<><Box sx={{ alignItems: 'flex-start' }}>
                                                <Skeleton variant="rectangular" animation="wave" height={250} /></Box></>) : (
                                                <>
                                                    {!(airfield.firstPhotoUrl == "" || airfield.firstPhotoUrl == null) ?
                                                        <CardMedia
                                                            component="img"
                                                            sx={{ height: 250 }}
                                                            image={airfield.firstPhotoUrl}
                                                            title=""

                                                        /> : <Box sx={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                                            <Typography sx={{ ml: 2, mt: 10, mb: 10, fontSize: 40 }}>
                                                                {airfield.icaoCode == null ? "ICAO_404" : airfield.icaoCode}</Typography>
                                                            <NoPhotographyIcon sx={{ mt: 9 }} />
                                                        </Box>}
                                                </>)}

                                            <CardContent>
                                                {!isSmallMobile ?
                                                    (<><Grid container rowSpacing={4} alignItems="center" justifyContent="space-between">
                                                        <Grid item xs={12}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                            }}>
                                                                <Typography align='center'><strong>{airfield.name}</strong></Typography>
                                                                {airfield.isRegistred &&
                                                                    <Box sx={{ ml: 1 }}
                                                                        component="img"
                                                                        src={verifiedShield}
                                                                        height={20}
                                                                    />
                                                                }
                                                            </Box>
                                                        </Grid>
                                                        <Grid item md={12} width={185} justifyContent="center" >
                                                            <Typography align='left'>ICAO: {airfield.icaoCode}</Typography>
                                                            <Typography align='left' sx={{ mt: 2 }}>{t("MUNICIPALITY_SHORT")}: {airfield.municipality}</Typography>
                                                        </Grid>
                                                        <Grid item md={12} width={185} justifyContent="center" >
                                                            <Typography align='right'>Prov: {airfield.province}</Typography>
                                                            <Typography align='right' sx={{ mt: 2 }}>Reg: {airfield.region}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    </>) :

                                                    (<><Grid container rowSpacing={4} justifyContent="flex-start"></Grid>
                                                        <Grid item xs={12}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-start',
                                                            }}>
                                                                <Typography align='left' sx={{ mt: 4, mb: 3 }}><strong>{airfield.name}</strong></Typography>
                                                                {airfield.isRegistred &&
                                                                    <Box sx={{ mt: 4, mb: 3, ml: 1 }}
                                                                        component="img"
                                                                        src={verifiedShield}
                                                                        height={20}
                                                                    />
                                                                }
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} justifyContent="left" >
                                                            <Typography align='left' sx={{ mt: 2 }}>ICAO: {airfield.icaoCode}</Typography>
                                                            <Typography align='left' sx={{ mt: 1 }}>{t("MUNICIPALITY_SHORT")}: {airfield.municipality}</Typography>
                                                            <Typography align='left' sx={{ mt: 1 }}>Prov: {airfield.province}</Typography></Grid>

                                                        <Grid item xs={12} justifyContent="left">
                                                            <Typography align='left' sx={{ mt: 1 }}>Reg: {airfield.region}</Typography>
                                                            <Typography align='left' sx={{ mt: 1 }}>Lat: {airfield.latitude}</Typography>
                                                            <Typography align='left' sx={{ mt: 1 }}>Lon: {airfield.longitude}</Typography></Grid>

                                                    </>)
                                                }
                                            </CardContent>



                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"

                                            >
                                                <Tooltip title={t('DETAILS') || ''} aria-label={t('DETAILS') || ''}>
                                                    <Button variant="contained" fullWidth sx={{ height: 40, color: "white" }}
                                                        style={{ borderRadius: 0 }}
                                                        component={RouterLink}
                                                        to={`details?airfieldId=${airfield.id}`}>
                                                        {t("MORE_INFO")}
                                                    </Button >
                                                </Tooltip>
                                            </Box>
                                        </Card>
                                    </Container >
                                    </>

                                )
                                )
                                }

                            </>



                        </TableBody>
                    </Table>)}
            </Scrollbar>

        </Container >
    );

};
export default AirfieldsPublicMobileList;
